import React, { useEffect, useState, Suspense, useMemo } from "react";
import { Col, Container, Row } from "react-bootstrap";
import jazz from "../../assets/images/svg/jazz.svg";
import zong from "../../assets/images/png/zong_logo.png";
import ufone from "../../assets/images/png/ufone-new.png";
import telenor from "../../assets/images/png/telenor-new.png";
import bannerImg from "../../assets/images/png/sign-up-banner.png";
import styled from "styled-components";
import { FiChevronRight } from "react-icons/fi";
import { FcGoogle } from "react-icons/fc";
import { Divider, Modal, Button, Select } from "antd";
// import Logo from "../../assets/images/svg/meri-sehat-logo.svg";
import Logo from "../../assets/images/png/meri-sehat-logo.png";
import "./SignupMobile.scss";
import { useHistory, useLocation } from "react-router-dom";
import encryptStorage from "../../utils/encryptStorage";
import API, { APIV3 } from "../../utils/customAxios";
import Loader from "../../uiComponents/loader/Loader";
import { isMobile } from "react-device-detect";
import { Accordion } from "react-bootstrap";
import i18n from "../../i18n";
import StickyTab from "../../uiComponents/stickyTab/StickyTab";
import arrowShape from "../../assets/images/svg/ShapeArrow.svg";
import NavbarSignup from "../../uiComponents/Navbar/NavbarSignup";
import SidebarSignup from "../../uiComponents/sideBar/SideBarSignUp";
import Footer from "../../uiComponents/Footer/Footer";
import { Link } from "react-router-dom";
import parse from "html-react-parser";
import $ from "jquery";
import VideoWidget from "../../uiComponents/videoWidget/videoWidget";
import mixpanel from 'mixpanel-browser';
import { useSelector } from "react-redux";
import { renderWidget } from "../../utils/common";
// import { renderWidget } from "@/utils/common";

const { Option } = Select;

const SignupMobile = () => {
  // const dispatch = useDispatch();
  const [continuePhoneNumber, setContinuePhoneNumber] = useState("");
  const [continueNetwork, setContinueNetwork] = useState("");
  const [continuePhoneError, setContinuePhoneError] = useState("");
  const [continueNetworkError, setContinueNetworkError] = useState("");
  const [apiLoading, setApiLoading] = useState(false);
  const [apiError, setApiError] = useState("");
  const [hideError, setHideError] = useState(false);
  const [mobile, setMobile] = useState(false);
  const [mobileform, setMobileForm] = useState(false);
  const [confirmFormSubmit, setConfirmFormSubmit] = useState(false);
  const [faqQuestions, setFaqQuestions] = useState();
  const { keys } = useSelector((state) => state.key);
  const [widgetsDrPage, setWidgetsDrPage] = useState([])

  // mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN_KEY);
  mixpanel.init(keys?.mixpanel_token_key);

  const handleRegister = () => {
    setConfirmFormSubmit(true);
  };
  const hideOtpError = () => {
    setHideError(true);
  };

  let footerBaseUrl = process.env.REACT_APP_FOOTER_BASE_URL;

  const history = useHistory();

  const signupOtp = () => {
    history.push("/signup-otp");
  };
  const menuList = [
    {
      link: "#overview",
      name: "Overview",
    },
    {
      link: "#badge",
      name: "Badge",
    },
    {
      link: "#reviews",
      name: "Your Reviews",
    },
  ];

  useEffect(() => {
    const timer = setTimeout(() => {
      mixpanel.track('Doctor signup view landing page');
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  const secondCharacter = continuePhoneNumber?.charAt(1);

  const navigateToOtp = async (e) => {
    e.preventDefault();

    setContinuePhoneError("");
    setContinueNetworkError("");

    if (continuePhoneNumber?.trim() === "") {
      setApiError(null);
      setContinuePhoneError("Please enter your mobile number");
    } else if (
      continuePhoneNumber?.trim()?.length < 10 ||
      continuePhoneNumber?.trim()?.length > 10
    ) {
      setApiError(null);
      setContinuePhoneError("Invalid mobile number");
    }
    else if (!/[0-4]/.test(secondCharacter)) {
      setApiError(null)
      setContinueNetworkError("Invalid mobile number");
    }
    // else if (continuePhoneNumber.length >= 2) {
    //   const secondCharacter = continuePhoneNumber.charAt(1);
    //   if (!/[0-4]/.test(secondCharacter)) {
    //     setContinueNetworkError("Invalid mobile number");
    //   }
    // }
    else {
      if (encryptStorage.getItem("signupPhone")) {
        encryptStorage.removeItem("signupPhone");
      }

      if (encryptStorage.getItem("signupNetwork")) {
        encryptStorage.removeItem("signupNetwork");
      }

      // localStorage.setItem("phone", continuePhoneNumber)
      encryptStorage.setItem("signupPhone", continuePhoneNumber);
      encryptStorage.setItem("signupNetwork", continueNetwork);

      const data = {
        phone: `0${continuePhoneNumber}`,
        network: continueNetwork,
      };

      localStorage.setItem("number", continuePhoneNumber);

      try {
        setApiLoading(true);
        const response = await API.post("/doctor/registration-short", data);

        if (response?.data?.code === 200) {
          setApiLoading(false);
          history.replace("/signup-otp");
        } else {
          setApiLoading(false);
          setApiError(response?.data?.message);
        }
      } catch (error) {
        setApiError(error?.response?.data?.message || error?.message);
        setApiLoading(false);
      }
    }
  };

  useEffect(() => {
    const persistNumber = localStorage.getItem("number");
    setContinuePhoneNumber(persistNumber);
    if (persistNumber?.startsWith("32") || persistNumber?.startsWith("30")) {
      setContinueNetwork("jazz");
    } else if (persistNumber?.startsWith("33")) {
      setContinueNetwork("ufone");
    } else if (persistNumber?.startsWith("34")) {
      setContinueNetwork("telenor");
    } else if (persistNumber?.startsWith("31")) {
      setContinueNetwork("zong");
    } else {
      setContinueNetwork("");
    }
  }, []);

  function generateArrayWithoutNumber() {
    let res = [];
    for (let i = 0; i <= 255; i++) {
      if (i >= 48 && i <= 57) {
      } else {
        res.push(String.fromCharCode(i));
      }
    }
    return res;
  }

  const arrayWithoutNumber = useMemo(() => generateArrayWithoutNumber(), []);

  function ContinuePhoneChange(e) {
    const limit = 10;
    setContinuePhoneNumber(e.target.value.slice(0, limit));

    if (e.target.value?.startsWith("32") || e.target.value?.startsWith("30")) {
      setContinueNetwork("jazz");
    } else if (e.target.value?.startsWith("33")) {
      setContinueNetwork("ufone");
    } else if (e.target.value?.startsWith("34")) {
      setContinueNetwork("telenor");
    } else if (e.target.value?.startsWith("31")) {
      setContinueNetwork("zong");
    } else {
      setContinueNetwork("");
    }
  }
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  useEffect(() => {
    let responseData = [];
    (async () => {
      const response = await API.get(`/faqs?category_id=10`);
      if (response?.data?.code === 200) {
        responseData.push(response?.data?.data);
      }
      setFaqQuestions(responseData);
    })();
  }, []);

  useEffect(() => {
    // Disable Mouse scrolling
    $("input[type=number]").on("mousewheel", function (e) {
      $(this).blur();
    });

    // Disable keyboard scrolling
    $("input[type=number]").on("keydown", function (e) {
      var key = e.charCode || e.keyCode;
      // Disable Up and Down Arrows on Keyboard
      if (key === 38 || key === 40) {
        e.preventDefault();
      } else {
        return;
      }
    });
  }, []);


  const getWidgets = async () => {
    try {
      const res = await APIV3.get(`/page/doctor-sign-up-v3`)
      console.log(res, "response")
      if (res?.status == 200) {
        setWidgetsDrPage(res?.data?.data?.widgets)
      }
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    getWidgets()
  }, []);

  return (
    <>

      <section className={"signUpPage"}>
        <Suspense fallback={<Loader />}>
          {widgetsDrPage?.map((item, index) => {
            const { key_type, card_type } = item;
            console.log("item ==>>.", item?.id)
            return (
              <div id={key_type === 'app-faq-v3' ? 'faq' : item?.id}>
                {renderWidget(key_type, item, index, false)}
              </div>
            )

          })}
        </Suspense>
      </section>
      {mobile && <StickyTab menuList={menuList} type="a" />}
      <StyledContinueNumber className="position-relative">
        {/* <div className="header_meriSehat d-sm-block d-none">
          <Container fluid>
            {apiLoading && <Loader />}
            <Row>
              <Col md={12}>
                <div className="logo_only">

                  <img src={Logo} alt="Logo" />

                </div>
              </Col>
            </Row>
          </Container>
        </div> */}

        {!isMobile ? (
          <>
            {" "}
            <NavbarSignup />
          </>
        ) : (
          <>
            <SidebarSignup />
          </>
        )}

      </StyledContinueNumber>
      {/* <section className="bg-white py-80 sec2MainArea" id="benefits">
        <Container>
          <Row className="align-items-center">
            <Col md={6}>
              <h3 className="mb-4 d-lg-none">
                Patients are searching professionals like you!
              </h3>
              <h3 className="mb-4 d-none d-lg-block titlinText">
                Patients are seeking <br className="d-none d-lg-block" />{" "}
                professionals like you!
              </h3>
              <ul className="ul_dots">
                <li>Get access to patients all across Pakistan</li>
                <li>Provide online video consultations </li>
                <li>
                  Earn through consultations at any time and from anywhere
                </li>
                <li>View and manage your appointments in one place </li>
                <li>Get verified patient feedback </li>
              </ul>
            </Col>
            <Col md={5}>
              <img src={secTwoImgg} alt="" className="img-fluid" />
            </Col>
          </Row>
        </Container>
      </section>
      <section className="py-80 sec2MainArea" id="registration">
        <Container>
          <Row className="align-items-center justify-content-center text-center">
            <Col md={4}>
              <h3 className="mb-5">
                Join Pakistan’s largest healthcare platform today
              </h3>
            </Col>
          </Row>
          <Row className="align-items-center justify-content-center">
            <Col md={3}>
              <div className="singleBoxArea text-left bg-white">
                <img src={iconOne} className="img-fluid mb-2" alt="Register" />
                <h5 className="mb-2">Register on dr.merisehat.pk</h5>
                <p>
                  Enter your name, mobile number, PMC number and your areas of
                  medical specialities.
                </p>
              </div>
            </Col>
            <Col md={3}>
              <div className="singleBoxArea text-left bg-white">
                <img src={iconTwo} className="img-fluid mb-3" alt="Register" />
                <h5 className="mb-2">Complete your profile</h5>
                <p>
                  Go through our introductory training and complete your
                  profile.
                </p>
              </div>
            </Col>
            <Col md={3}>
              <div className="singleBoxArea text-left bg-white">
                <img
                  src={iconThree}
                  className="img-fluid mb-3"
                  alt="Register"
                />
                <h5 className="mb-2">Profile Verification</h5>
                <p>Await verification from Meri Sehat, and go live!</p>
              </div>
            </Col>
            <Col md={3}>
              <div className="singleBoxArea text-left bg-white">
                <img src={iconFour} className="img-fluid mb-2" alt="Register" />
                <h5 className="mb-2">Start Earning</h5>
                <p>
                  Connect with patients and start earning through in-person or
                  online video consultations.{" "}
                </p>
              </div>
            </Col>
            <Col md={4}>
              <div className="d-block d-lg-none">
                <a
                  href="#banner-form"
                  onClick={() => scrollToSection("banner-form")}
                  className="   review-button mt-3 mt-lg-5 text-uppercase registerBtns position-relative fw-700"
                >
                  {" "}
                  Register Now
                  <span
                    className="continue-phone-chevron instant-code-chev d-none d-lg-flex"
                    style={{ height: "53px" }}
                  >
                    <FiChevronRight />
                  </span>
                </a>
              </div>
              <div className="d-none d-lg-block">
                <button
                  onClick={(e) => window.scrollTo({ top: 0, left: 0 })}
                  type="submit"
                  className="  review-button mt-3 mt-lg-5 text-uppercase registerBtns position-relative fw-700"
                >
                  Register Now
                  <span
                    className="continue-phone-chevron instant-code-chev d-none d-lg-flex"
                    style={{ height: "53px" }}
                  >
                    <FiChevronRight />
                  </span>
                </button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="bg-white py-80 whyUsArea" id="whychooseus">
        <Container>
          <Row className="m-0">
            <Col md={5}>
              <h3 className="mb-5">Why choose us</h3>
              <div className="d-flex align-items-start mb-4">
                <div className="me-3 col-2 col-lg-1 ">
                  <img
                    src={chooseIconOne}
                    alt=""
                    className="img-fluid mob_size"
                  />
                </div>
                <div className="col-10 col-lg-11">
                  <div className="box_chose">
                    <h5 className="mb-2">Grow your practice</h5>
                    <p>
                      Get access to enterprise-level medical software to help
                      your practice thrive.
                    </p>
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-start mb-4">
                <div className="me-3 col-2 col-lg-1">
                  <img
                    src={chooseIconTwo}
                    alt=""
                    className="img-fluid mob_size"
                  />
                </div>
                <div className="col-10 col-lg-11">
                  <div className="box_chose">
                    <h5 className="mb-2">Earn remotely</h5>
                    <p>
                      Earn money by offering online video consultations from any
                      location and at any time.
                    </p>
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-start mb-4">
                <div className="me-3 col-2 col-lg-1 ">
                  <img
                    src={chooseIconThree}
                    alt=""
                    className="img-fluid mob_size"
                  />
                </div>
                <div className="col-10 col-lg-11">
                  <div className="box_chose">
                    <h5 className="mb-2">Keep track of your patients </h5>
                    <p>
                      Have easy access to your patients medical history and
                      prescriptions.
                    </p>
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-start mb-4">
                <div className="me-3 col-2 col-lg-1 ">
                  <img
                    src={chooseIconFour}
                    alt=""
                    className="img-fluid mob_size"
                  />
                </div>
                <div className="col-10 col-lg-11">
                  <div className="box_chose">
                    <h5 className="mb-2">Strengthen your credibility </h5>
                    <p>Join a community of PMC certified doctors.</p>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={5} className="offset-md-1">
              <img src={secTwoFour} alt="" className="img-fluid" />
            </Col>
          </Row>
        </Container>
      </section>
      <section className="py-80 sec2MainArea featureAreaBox" id="featured">
        <Container>
          <Row className="align-items-center justify-content-center">
             

            <Col md={6} className="order-2 order-lg-1 mt-5 mt-lg-0">
              <VideoWidget />
            </Col>

            <Col md={5} className="offset-md-1 text-left order-1 order-lg-2">
              <h3 className="mb-3">Feature in our health videos</h3>
              <div className="w-80 mob-100">
                <p>
                  Meri Sehat has the largest health directory in the country,
                  containing 4000+ disease articles available in both English
                  and Urdu, as well as disease videos in major regional
                  languages.{" "}
                </p>
                <Col md={9}>
                  <button
                    onClick={(e) => window.scrollTo({ top: 0, left: 0 })}
                    type="submit"
                    className="review-button mt-5 text-uppercase registerBtns position-relative fw-700 d-none d-lg-flex"
                  >
                    Register Now
                    <span
                      className="continue-phone-chevron instant-code-chev"
                      style={{ height: "53px" }}
                    >
                      <FiChevronRight />
                    </span>
                  </button>
                </Col>
              </div>
            </Col>
          </Row>
        </Container>
      </section> */}

      {/* <section className="py-80 instantFAQ bg-white" id="faq">
        <Container>
          <h3 className="mb-4 d-none d-lg-block">{i18n.t("faqs")}</h3>
          <h3 className="mb-4 d-lg-none">{i18n.t("faqsss")}</h3>
          {faqQuestions?.[0]?.map((faqs, index) => (
            <Accordion defaultActiveKey={0}>
              <Accordion.Item
                className="pricing-accordion-item"
                key={index}
                eventKey="0"
              >
                <Accordion.Header className="pricing-accordion-question">
                  {faqs?.question}
                </Accordion.Header>
                <Accordion.Body className="pricing-accordion-answer">
                  {faqs?.answer}
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          ))}
        </Container>
      </section> */}
      <Footer />
    </>
  );
};

export const StyledContinueNumber = styled.section`
  /* .LogoStyled{
        padding-top: 35px;
    } */

  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="number"] {
    -moz-appearance: textfield;
    /* Firefox */
  }

  .borderedRed {
    border: 1.5px solid red;
    border-radius: 11px;
  }


  .numberRed {
    color: #b11b1b !important;
  }

  .enter-mobile {
    color: #19b3b5;
    font-family: 'Satoshi-Medium';
    font-style: normal;
    font-weight: 450;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
  }
  .continue-number-box {
    background-color: #fff;
    border-radius: 12px;
  }
  .continue-heading {
    padding: 0 40px;
    margin-top: 50px;

    h4 {
      font-family: 'Satoshi-Medium';
      font-style: normal;
      font-weight: 500;
      font-size: 36px;
      line-height: 45px;
      /* or 125% */

      letter-spacing: 0.01em;

      color: #313131;
    }

    p {
      font-family: 'Satoshi-Light';
      font-style: normal;
      font-weight: 300;
      font-size: 18px;
      line-height: 25px;

      color: #404040;
    }
  }

  .description-circle-group {
    margin-left: 2.3rem;
    margin-top: 25px;

    p {
      font-family: 'Satoshi-Medium';
      font-style: normal;
      font-weight: 450;
      font-size: 18px;
      line-height: 23px;
      color: #313131;
      display: flex;
      align-items: center;
    }
  }

  .line-divider {
    display: flex;
    justify-content: center;
    padding: 15px 4px 0 4px;

    span {
      margin-top: 10px;
      padding: 0 4px;
    }
  }

  .continue-phone-btn {
    border-radius: 12px;
    background-color: #19b3b5;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 53px;
    padding: 0;
    width: 100%;
    font-family: 'Satoshi-Bold';
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 25px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.05em;
    color: #ffffff;

    .continue-phone-chevron {
      float: right;
      background-color: #078a8e !important;
      font-size: 16px;
      height: 44px;
      width: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 0px 10px 10px 0px;
      position: absolute;
      right: 0;
      left: auto;
    }
  }

  .boxLineCut {
    border: 0.3px solid #313131;
    height: auto;
    width: 80%;
    margin: auto;
    padding-bottom: 1rem;

    .btn-apple12 {
      width: 100%;
      cursor: pointer;
    }
  }

  .boxLineCut h1 {
    width: 75%;
    margin-top: -15px;
    margin-left: auto;
    margin-right: auto;
    background: #e1f3f4;
    font-size: 16px;
    line-height: 28px;
    text-align: center;
  }

  .doctor-error-msg p {
    margin-top: 0px;
    margin-left: 80px;
    // background-color: #fee6e6;
    padding: 3px;
    border-radius: 6px;
    display: flex;
    justify-content: space-between;
    color: #b11b1b;
    font-family: 'Satoshi-Medium';
    font-style: normal;
    font-weight: 450;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    color: #bc0001;
    margin-top: 7px;
      word-spacing: -3px;
    .bsX {
      cursor: pointer;
      margin-top: 2px;
      font-size: 20px;
    }
  }
  @media (min-width: 0px) and (max-width: 767px) {
    .doctor-error-msg {
      p {
        margin-left: 62px !important;
        font-size: 12.5px;
      }
    }
  }
`;

export default SignupMobile;
